import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "store";

interface AuthState {
  isFetchingDetector: boolean;
  isFetchingPosicheck: boolean;
  requestFailed: boolean;
}

const initialState: AuthState = {
  isFetchingDetector: false,
  isFetchingPosicheck: false,
  requestFailed: false,
};

const detectorSlice = createSlice({
  name: "DetailPage",
  initialState,
  reducers: {
    fetchDetector: (state, action) => {
      state.isFetchingDetector = action.payload.isFetchingDetector;
    },
    fetchPosicheck: (state, action) => {
      state.isFetchingPosicheck = action.payload.isFetchingPosicheck;
    },
    setRequestFailed: (state, action) => {
      state.requestFailed = action.payload.requestFailed;
    },
  },
});

export const { fetchDetector, fetchPosicheck, setRequestFailed } = detectorSlice.actions;
export const isFetchingDetector = (state: RootState) => state.detector.isFetchingDetector;
export const isFetchingPosicheck = (state: RootState) => state.detector.isFetchingPosicheck;
export const requestFailed = (state: RootState) => state.detector.requestFailed;
export default detectorSlice;
